module.exports = __webpack_public_path__ + "static/media/use_esim_zhcn1.a25a49d0.png";